.gx{border:1px solid #ddd;}